const clickAddButton = (clickEvent) => {
    const clickedElem = clickEvent.currentTarget;
    const buttonTarget = clickedElem.dataset.target || null;
    const tinyMCEConfig = clickedElem.dataset.tinymceConfig || null;
    const placeholder = clickedElem.dataset.placeholder || 'index';
    const replacePattern = '__' + placeholder + '__';
    const placeholderRegex = new RegExp(replacePattern, 'g');
    const maxCount = parseInt(clickedElem.dataset.maxCount || 'infinite');

    let targetElementContainer = null;
    let targetElementTemplate = null;

    // Search for Button Target Template
    if (buttonTarget) {
        // Get parent fieldset content containing the searched fieldset
        const parentFieldset = clickedElem.closest(
            'fieldset[data-tcms-name]:not([data-tcms-fieldset="buttons"]) > .fieldCollection-content'
        );

        targetElementContainer = parentFieldset.querySelector(
            'fieldset[data-typ="' + buttonTarget + '"] > .fieldCollection-content > .fieldCollection-content-left'
        );
        targetElementTemplate = parentFieldset.querySelector(
            'fieldset[data-typ="' +
            buttonTarget +
            '"] > .fieldCollection-content > .fieldCollection-content-left > span[data-template]'
        );
    }

    // TODO: Add data attribute to trigger function after click for element

    if (targetElementContainer) {
        // Get template of box to add

        let boxTemplate = targetElementTemplate ? targetElementTemplate.dataset.template : null;
        let currentSubCount = targetElementContainer.querySelectorAll(
            '.js-inject-fieldset, .js-inject-attribute-fieldset'
        ).length;

        if (boxTemplate) {
            boxTemplate = boxTemplate.replace(placeholderRegex, ++currentSubCount);
            const fragment = new DocumentFragment();
            const tmpEl = document.createElement('div');

            tmpEl.innerHTML = boxTemplate;
            fragment.append(tmpEl.firstChild);

            fragment.querySelector;

            targetElementContainer.appendChild(fragment);

            // Hide Add Button when max count reached
            toggleAddButton(clickedElem, currentSubCount, maxCount);
        }
    }

    //    initTreeAutocompleter(parentFieldset);
    //    initTinyMce(tinymceConfig);
    //    jQuery(':input', parentFieldset).tooltip();
    //    addRemoveButton(
    //        parentFieldset.find('> .js-inject-attribute-fieldset:last, > .js-inject-fieldset:last'),
    //        jQuery(this)
    //    );
    //    hideAttributeSelect(parentFieldset.find(' > .js-inject-fieldset:last'));
    //    hideContentElementsOnlySelfElements();
    //    addSelectFunction(parentFieldset.find(' > .js-inject-fieldset:last'));
    //
    //    if (typeof setClickListenerToPSPElement === 'function') {
    //        setClickListenerToPSPElement();
    //    }
    //
    //    if (maxCount != undefined && !isNaN(maxCount)
    //        && maxCount <= parentFieldset.find('> .js-inject-attribute-fieldset, > .js-inject-fieldset').length
    //    ) {
    //        jQuery(selector).hide();
    //    }
    //
    //    if (typeof zf2DoctrineAutocomplete != "undefined") {
    //        zf2DoctrineAutocomplete.init("body");
    //    }
    //
    //    searchBoxSelctionFilter();
};

const toggleAddButton = (btnElem, count, max) => {
    if (max === 'infinite') {
        if (count >= max) {
            btnElem.classList.add('hide');
        } else {
            btnElem.classList.remove('hide');
        }
    }
};

const addButtonClickDynamic = () => {
    // Only selects buttons that have the data-event-attached value not to true
    document
        .querySelectorAll('.js-add-inject-attribute, .js-add-fieldset:not([data-event-attached="true"])')
        .forEach((elem) => {
            elem.addEventListener('click', (e) => {
                e.preventDefault();
                // Fire action button
                clickAddButton(e);

                // After adding new buttons (maybe) check again
                addButtonClickDynamic();
            });

            // Set data attribute to see if event was attached
            elem.dataset.eventAttached = 'true';
        });

    document.querySelectorAll('.js-remove-fieldset:not([data-event-attached="true"])').forEach((elem) => {
        elem.addEventListener('click', (e) => {
            e.preventDefault();
            // Fire action button
            removeButtonEvent(e);

            // After adding new buttons (maybe) check again
            addButtonClickDynamic();
        });

        // Set data attribute to see if event was attached
        elem.dataset.eventAttached = 'true';
    });
};

const removeButtonEvent = (e) => {
    const btn = e.currentTarget;
    const targetFieldsetId = btn.dataset.targetId;
    const targetFieldset = btn.closest('fieldset[data-tcms-fieldset="box"]');

    if (targetFieldset) {
        targetFieldset.remove();
    }
};

// Execute one time
addButtonClickDynamic();
